import { useUserStore } from '../../store/useUserStore';
import moment from 'moment';
import { forwardRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';

import IcProfile from '../../assets/image/ic_profile.svg';
import IcDot from '../../assets/image/report/ic_dots_btn.svg';


interface CommentCardProps {
  comment: any;
  optionClick: (id: number) => void;
}

const CommentCard = forwardRef<HTMLDivElement, CommentCardProps>(
  ({ comment, optionClick }, ref) => {
    const navigate = useNavigate();
    const isLoggedIn = useUserStore((s) => s.isLoggedIn);

    const handleOptionClick = useCallback(
      (commentId) => {
        if (isLoggedIn) {
          optionClick(commentId);
        } else {
          navigate(Url.Login);
        }
      },
      [isLoggedIn, navigate]
    );

    return (
      <div
        ref={ref}
        className="w-full flex items-start justify-start gap-2 py-4 border-b border-gray-200 hover:bg-gray-50"
      >
        <div
          className="shrink-0 min-w-[52px] max-w-[52px] min-h-[52px] max-h-[52px] bg-[#FFF] border border-[#EAEAEA] overflow-hidden flex items-center justify-center rounded-[24px]"
          // style={{ background: Math.random() > 0.5 ? '#fff' : '#F0FCFC' }}
        >
          <img
            src={comment?.author?.imageUrl ? comment?.author?.imageUrl : IcProfile}
            alt="profile"
            className="w-[52px] object-cover rounded-full"
          />
        </div>
        <div className="grow flex flex-col items-start justify-start gap-2 font-[400] text-[#363636] text-[12px]">
          <div className="w-full flex justify-between items-start">
            <div>
              <div className="font-[700] text-[#1C1C1C] text-[16px]">
                {comment?.author?.nickName}
              </div>
              <div className="text-left text-[#969696]">
                {moment(comment?.createdAt).format('YY.MM.DD')}
              </div>
            </div>
            <div className="flex items-center justify-end gap-1">
              <button type="button" onClick={() => handleOptionClick(comment?.id)}>
                <img src={IcDot} alt="more options" className="w-[18px] h-[18px]" />
              </button>
            </div>
          </div>
          <div className="text-left">{comment?.content}</div>
        </div>
      </div>
    );
  }
);

export default CommentCard;
